import CryptoJS from 'crypto-js';

const ENCRYPTION_KEY = process.env.REACT_APP_ENCRYPTION_KEY || 'my-dev-key-123';

/**
* Encrypts data using AES encryption
* @param {any} data - Data to encrypt (will be stringified if object)
* @returns {string} - Encrypted string
*/
export const encryptData = (data) => {
    try {
        const dataString = typeof data === 'string' ? data : JSON.stringify(data);
        const encrypted = CryptoJS.AES.encrypt(dataString, ENCRYPTION_KEY).toString();
        return encrypted;
    } catch (error) {
        console.error('Encryption error:', error);
        return null;
    }
};
 